<template>
    <div>
        <div class="flex flex-col">
            <div class="w-full">
                <load-file>
                    <template v-slot:default="slotProps">
                        <a @click="slotProps.open" class="rounded cursor-pointer p-4 mb-8 mr-8 block hover:bg-blue-lighter hover:border-blue-dark flex text-blue-dark">
                            <div class="p-2">
                                <i class="fa fa-2x fa-fw fa-folder-open-o"></i>
                            </div>
                            <div>
                                <div class="leading-normal uppercase">
                                    Load Report
                                </div>
                                <div class="text-grey-dark text-sm">
                                    Load an existing Report
                                </div>
                            </div>
                        </a>
                    </template>
                </load-file>
            </div>
            <div class="w-full">
                <add-series init="custom">
                    <template v-slot:default="slotProps">
                        <a @click="slotProps.doMenu"
                           class="rounded cursor-pointer p-4 mb-8 mr-8 block hover:bg-blue-lighter hover:border-blue-dark flex text-blue-dark">
                            <div class="p-2">
                                <i class="fa fa-2x fa-fw fa-book"></i>
                            </div>
                            <div>
                                <div>
                                    <span  class="leading-normal uppercase">Data Library</span>
                                    <span>powered by AllThatStats</span>
                                </div>
                                <div class="text-grey-dark text-sm">
                                    Use AllThatStats data library to find data that suits your needs.
                                </div>
                            </div>

                        </a>
                    </template>
                </add-series>

            </div>
            <div class="w-full">
                <import-data>
                    <template v-slot:default="slotProps">
                        <a @click="slotProps.open" class="rounded cursor-pointer p-4 mb-8 mr-8 block hover:bg-blue-lighter hover:border-blue-dark flex text-blue-dark">
                            <div class="p-2">
                                <i class="fa fa-2x fa-fw fa-upload"></i>
                            </div>
                            <div>
                                <div class="leading-normal uppercase">
                                    Import Data
                                </div>
                                <div class="text-grey-dark text-sm">
                                    Import your data for a quick analysis or to update your time series with more recent data.
                                </div>
                            </div>
                        </a>
                    </template>
                </import-data>
            </div>
        </div>
    </div>
</template>

<script>
    import ImportData from "./import/ImportData";
    export default {
        name: "NewDashboard",
        components: {ImportData}
    }
</script>

<style scoped>

</style>
